<template>
  <div class="test-check">
    <TestConditionModal
      :showModal.sync="showModal"
      :testCondition="testCondition"
    />
    <TestingModal :showModal.sync="showOverModal" :remindType="remindType" />
  </div>
</template>

<script>
import TestConditionModal from "./TestConditionModal";
import TestingModal from "../../test/components/TestingModal";

export default {
  name: "TestCheckModal",
  components: {
    TestConditionModal,
    TestingModal,
  },
  data() {
    return {
      showModal: false, //课程列表
      testCondition: {},
      showOverModal: false, //考试下架提醒，过期提醒
      remindType: {}, //提醒类型，文本
    };
  },
  methods: {
    init(id) {
      return new Promise(async resolve => {
        //先校验是否达到考试条件，如果没有
        const res = await this.$http.get(`/api/app/test/doTest/${id}`);
        if (res.isFinishCondition == 0 || res.isFinishCondition == 2) {
          await this.getCourseList(id);
          this.showModal = true;
          return;
        } else if (res.isFinishCondition == 3) {
          this.remindType = {
            type: 5,
          };
          this.showOverModal = true;
          return;
        } else if (res.isFinishCondition == 4) {
          this.remindType = {
            type: 3,
          };
          this.showOverModal = true;
          return;
        } else if (res.isFinishCondition == 5) {
          this.remindType = {
            type: 6,
          };
          this.showOverModal = true;
          return;
        } else if (res.isFinishCondition == 6) {
          this.remindType = {
            type: 7,
          };
          this.showOverModal = true;
          return;
        } else if (res.isFinishCondition == 7) {
          this.remindType = {
            type: 8,
          };
          this.showOverModal = true;
          return;
        } else if (res.isFinishCondition == 8) {
          this.remindType = {
            type: 9,
          };
          this.showOverModal = true;
          return;
        }
        resolve();
      });
    },
    async getCourseList(id) {
      const res = await this.$http.get("/api/app/test/testCondition", {
        id: id,
      });
      this.testCondition = {
        name: res[0].test_title,
        courseList: res || [],
        join_type: res[0].join_type,
      };
    },
  },
};
</script>

<style scoped></style>
